import "./libs/swiper.js";
import "./blocks/life-gallery.js";
import "./blocks/infrastructure.js";
import "./blocks/scrollTo.js";
import "./blocks/history-page.js";
import AOS from "../../../../../node_modules/aos/dist/aos.js";
import { initTabs } from "./blocks/tabs.js";
import {
  initCirclesSlider,
  initInfrostructureSlider,
  initDeadlinesSlider,
  initHistorySlider,
  initHistoryFacesSlider,
  switchHistoryTo,
  scrollToId,
  initPartnersSlider,
} from "./blocks/sliders.js";
import { initVidios } from "./blocks/video.js";
import { initCopyLinks } from "./blocks/copyLink.js";
import { initContentManager } from "./blocks/contentManager.js";
import { initProfessionsList } from "./blocks/professions-list.js";
import { initModal } from "./blocks/modals2.js";
import {
  initQuiz,
  blinkBrain,
  showHistoryForm,
  hideHistoryForm,
  nextQuizCard,
} from "./blocks/history-quiz.js";

window.addEventListener("DOMContentLoaded", () => {
  AOS.init({
    once: true,
    startEvent: "DOMContentLoaded",
  });
  // initTabs();
  initVidios();
  initCopyLinks();
  initContentManager();
  initProfessionsList();

  initModal("modal1", "modal1");
  initDeadlinesSlider();
  initHistorySlider();
  initHistoryFacesSlider();
  initPartnersSlider();
  initCirclesSlider();
  initInfrostructureSlider();
  setTimeout(function () {
    AOS.refresh();
  }, 500);
  initQuiz();

  window.initDeadlinesSlider = initDeadlinesSlider;
  window.initHistorySlider = initHistorySlider;
  window.initHistoryFacesSlider = initHistoryFacesSlider;
  window.initQuiz = initQuiz;
  window.blinkBrain = blinkBrain;
  window.showHistoryForm = showHistoryForm;
  window.hideHistoryForm = hideHistoryForm;
  window.switchHistoryTo = switchHistoryTo;
  window.scrollToId = scrollToId;
  window.nextQuizCard = nextQuizCard;
  window.initInfrostructureSlider = initInfrostructureSlider;
});
